<template>
  <div class="otp-wrapper">
    <div
      v-for="(_, index) in 6"
      :key="index"
      class="otp-box"
      :class="{ active: activeIndex === index }"
      @click="focusInput(index)"
    >
      <input
        ref="inputs"
        v-model="digits[index]"
        class="otp-input"
        maxlength="1"
        @input="handleInput(index)"
        @keydown="handleKeydown($event, index)"
        @paste="handlePaste"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "OtpInput",
  props: {
    value: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      digits: ["", "", "", "", "", ""],
      activeIndex: -1
    };
  },

  watch: {
    // v-model → digits
    value(newVal) {
      if (newVal.length === 6) {
        this.digits = newVal.split("");
      }
    },

    // digits → v-model
    digits: {
      deep: true,
      handler() {
        const otp = this.digits.join("");
        this.$emit("input", otp);

        // 自动提交
        if (otp.length === 6 && /^\d{6}$/.test(otp)) {
          this.$emit("complete", otp);
        }
      }
    }
  },

  methods: {
    // 聚焦具体 input
    focusInput(index) {
      this.activeIndex = index;
      this.$refs.inputs[index].focus();
    },

    // 输入数字 + 自动跳格
    handleInput(index) {
      // 只允许数字
      this.digits[index] = this.digits[index].replace(/\D/g, "");

      // 自动跳下一个
      if (this.digits[index] && index < 5) {
        this.focusInput(index + 1);
      }
    },

    // 删除自动跳回
    handleKeydown(e, index) {
      if (e.key === "Backspace") {
        if (!this.digits[index] && index > 0) {
          this.focusInput(index - 1);
        }
      }
    },

    // 粘贴 "123456" 自动分割
    handlePaste(e) {
      const text = e.clipboardData.getData("text").replace(/\D/g, "");
      if (text.length === 6) {
        this.digits = text.split("");
      }
    }
  }
};
</script>

<style scoped>
/* 容器 */
.otp-wrapper {
  display: flex;
  justify-content: center;
  gap: 10px;
}

/* 每个输入格子 */
.otp-box {
  width: 48px;
  height: 48px;
  border: 1px solid #3634346b;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: text;
  transition: all 0.2s ease;
}

/* 聚焦时边框高亮（模仿 Element UI 的蓝色边框） */
.otp-box.active {
  border-color: #409EFF;
}

/* 输入框（透明背景） */
.otp-input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  text-align: center;
  font-size: 20px;
  background: transparent;
  caret-color: #409EFF; /* 光标蓝色 */
}

/* 去掉 input 自带的 outline */
.otp-input:focus {
  outline: none;
}
</style>
